// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4273":"2a5f7c6b","8089":"b2bb917e","8688":"c979e12a","8864":"d4c32a44"}[chunkId] + ".chunk.css";
};